/* Featured product gallery: on desktop the thumbnail rail fades the active media
   item in and out; below the desktop breakpoint the media list is a scroll-snap
   slider and the thumbs render as dots, so selection follows scroll position and
   a dot press scrolls rather than fades. */
class FeaturedGallery extends HTMLElement {
  connectedCallback() {
    this.thumbs = Array.from(this.querySelectorAll('.featured-product__thumb'));
    this.items = Array.from(this.querySelectorAll('.featured-product__media-item'));
    this.media = this.querySelector('.featured-product__media');
    this.desktop = window.matchMedia('(min-width: 1024px)');
    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.select(thumb.dataset.mediaIndex));
    });
    if (this.media) {
      let queued = false;
      this.media.addEventListener('scroll', () => {
        if (this.desktop.matches || queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          const step = this.items.length > 1
            ? this.items[1].offsetLeft - this.items[0].offsetLeft
            : 1;
          this.mark(String(Math.round(this.media.scrollLeft / step)));
        });
      }, { passive: true });
    }
  }

  select(index) {
    if (this.desktop.matches) {
      this.items.forEach((item) => {
        item.classList.toggle('is-active', item.dataset.mediaIndex === index);
      });
      this.mark(index);
    } else if (this.media) {
      const target = this.items.find((item) => item.dataset.mediaIndex === index);
      if (target) {
        this.media.scrollTo({
          left: target.offsetLeft - this.items[0].offsetLeft,
          behavior: 'smooth'
        });
      }
    }
  }

  mark(index) {
    this.thumbs.forEach((thumb) => {
      thumb.setAttribute('aria-selected', String(thumb.dataset.mediaIndex === index));
    });
    // The spinning badge belongs to the primary photo only (merchant decision,
    // 2026-09-06); the section CSS fades it while any other media is active.
    this.classList.toggle('is-beyond-first', index !== '0');
  }
}

if (!customElements.get('featured-gallery')) {
  customElements.define('featured-gallery', FeaturedGallery);
}
